import { storeCode, layoutCode, componentCode, configCode, PageCode, i18nCode, i18nConf } from "../types/example-forms.js"
import { handelTypeOfFile } from "../methods/write-file.js"
/**
  * chech of type of module
  * @param path - The path for file with file name.ext .
  * @param type  - type of file is (component | page | store | route) 
  * @param fileName  - name of directory
  */
export function createVueFile(path, type, fileName) {
    switch (type) {
        case "component":
            handelTypeOfFile(path, type, componentCode, fileName);
            break;
        case "layout":
            handelTypeOfFile(path, type, layoutCode, fileName);
            break;
        case "store":
            handelTypeOfFile(path, type, storeCode, fileName);
            break;
        case "config":
            handelTypeOfFile(path, type, configCode, fileName);
            break;
        case "page":
            handelTypeOfFile(path, type, PageCode, fileName);
            break;
        case "i18n":
            handelTypeOfFile(path, type, i18nCode, fileName);
            break;
        case "i18n_conf":
            handelTypeOfFile(path, type, i18nConf, fileName);
            break;
        default:
            console.error(`Unknown type: ${type}`);
    }
}